<template>
  <a-layout class="index animated fadeIn">
    <a-card :bordered="false">
      <div disabled>
        <a-steps v-model:current="current" type="navigation" size="small"
          :style="{marginBottom: '60px',boxShadow: '0px -1px 0 0 #e8e8e8 inset'}">
          <a-step status="finish" disabled title="设置礼品" />
          <a-step status="finish" disabled title="编辑兑换规则" />
          <a-step status="finish" disabled title="设置成功" />
        </a-steps>
      </div>
      <div class="content " v-show="current == 0">
        <a-tabs v-model:activeKey="activeKey" v-if='showTab'>
          <a-tab-pane :key="1" tab="自有礼品">
            <selectGiftLibrary v-on:select="selectGift" :selectList='giftList' />
          </a-tab-pane>
          <a-tab-pane :key="2" tab="产品库">
            <selectGood v-on:select="goodSelect" :selectList='goodList' />
          </a-tab-pane>
        </a-tabs>
        <a-button @click="current = 1" v-if='$route.query.id'>下一步</a-button>
      </div>
      <div class="content " v-show="current == 1">
        <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-item ref="" label="已选礼品" name="">
            <a-card-meta :title="selectGood.product_name || selectGood.gift_name">
              <template #avatar>
                <img :src="info.picdomain+'/'+(selectGood.product_image||selectGood.cover_image_url)" alt=""
                  style="width:50px;height: 50px;object-fit:cover">
              </template>
            </a-card-meta>
          </a-form-item>
          <a-form-item ref="" label="市场价" name="">￥{{selectGood.product_price || selectGood.market_price}}</a-form-item>
          <a-form-item required label="分类" name="">
            <a-cascader style="width:50%" v-model:value="valueCate" :options="options" placeholder="请选择产品分类"
              :field-names="{ label: 'name', value: 'id',children :'child' }" />
            <a-button type="link" @click='openNewUrl("/integralShop/giftExchange/giftCate")'>管理分类</a-button>
            <a-button type="link" @click='initCate'>刷新</a-button>
          </a-form-item>
          <a-form-item ref="" label="积分价格" name="price_type">
            <a-radio-group v-model:value="form.price_type">
              <a-radio :value="1">纯积分</a-radio>
              <a-radio :value="2">积分+现金</a-radio>
            </a-radio-group>
            <div class="s_flex_ali width50" v-if='selectGood.spec_type == 1'>
              <a-input-number class="width41" v-model:value="form.point" placeholder='请输入积分' :min="0" :precision='0' />
              <p class="m-l-10 m-r-10">积分<span v-if="form.price_type == 2" >+</span></p>
              <a-input-number class="width41" v-model:value="form.price" placeholder='请输入金额' :min="0" :precision='2'
              v-if="form.price_type == 2" />
              <p class="m-l-10" v-if="form.price_type == 2">现金</p>
            </div>
            <div class="s_flex_ali">
              <p class="s_c999">参考积分价：{{exchange_point}} 积分 （计算公式：1元＝ {{exchange_point}} 积分 ）</p>
              <a-button type="link" @click='openNewUrl("/assets/integral/set?active=4")'>编辑</a-button>
              <a-button type="link" @click='getPointSet'>刷新</a-button>
            </div>
          </a-form-item>
          <a-form-item ref="" label="可兑换数量" name="use_exchange_num">
            <a-input-number class="width50" v-model:value="form.use_exchange_num" placeholder='请输入可兑换数量' :min="0" :precision='0'
              v-if='selectGood.spec_type == 1' />
            <a-table :pagination='false' :loading='listLoading' bordered rowKey='sku_sn' :columns='columns'
              :data-source='selectGood.sku' v-else>
              <template v-slot:info="{ record }">
                <a-card-meta>
                  <template #avatar>
                    <img :src="info.picdomain+record.image_url" alt="" style="width:50px;height: 50px;object-fit:cover">
                  </template>
                  <template #description>{{record.spec_value || record.sku_value}}</template>
                </a-card-meta>
              </template>
              <template v-slot:stock="{ record }">
                <a-input-number class='width100' v-model:value="record.use_exchange_num" placeholder='请输入数量' :min="0" :precision='0' />
              </template>
              <template v-slot:price="{ record }">
                <div class="s_flex_ali width100">
                  <a-input-number class="width41" v-model:value="record.exchange_point" placeholder='请输入积分' :min="0" :precision='0' />
                  <p class="m-l-10 m-r-10">积分<span v-if="form.price_type == 2" >+</span></p>
                  <a-input-number class="width41" v-model:value="record.exchange_price" placeholder='请输入金额'
                  :min="0" :precision='2' v-if="form.price_type == 2" />
                  <p class="m-l-10" v-if="form.price_type == 2">现金</p>
                </div>
              </template>
            </a-table>
          </a-form-item>
          <a-form-item ref="" label="可兑换权限" name="">
            <a-checkbox v-model:checked="form.limit_num">限兑数量</a-checkbox>
            <div class="s_flex_ali" v-if='form.limit_num'>
              <a-select v-model:value="form.use_exchange_num_json.date_type" :style="{width:'200px'}" placeholder="请选择">
                <a-select-option :value="1">长期</a-select-option>
                <a-select-option :value="2">每月</a-select-option>
              </a-select>
              <p class="m-l-10 m-r-10">每人兑换</p>
              <a-input-number class='width-150' v-model:value="form.use_exchange_num_json.number" placeholder='请输入次数'
                :min="0" :precision='0' />
              <p class="s_c999">（指定时段内，每会员ID限兑N，超过后不可再下单兑换）</p>
            </div>
            <a-checkbox v-model:checked="form.limit_use">限兑用户</a-checkbox>
            <div v-if='form.limit_use'>
              <a-radio-group v-model:value="form.level_type">
                <a-radio :value="1">固定的等级</a-radio>
                <a-radio :value="2">指定等级</a-radio>
              </a-radio-group>
              <div>
                <a-select v-model:value="form.level_id" :style="{width:'300px'}" placeholder="请选择会员等级">
                  <a-select-option v-for='item in levelList' :key='item.vip_id' :value="item.vip_id">
                    {{item.vip_name}}{{form.level_type==1 ?'以上':''}}</a-select-option>
                </a-select>
              </div>
            </div>
            <a-checkbox v-model:checked="form.is_use_exchange_time" @change='form.is_use_exchange_time = form.is_use_exchange_time ? 1:0'>限时兑换</a-checkbox>
            <div v-if='form.is_use_exchange_time'>
              <a-range-picker :show-time="{
                hideDisabledOptions: true,
                defaultValue: [momentTime('00:00:00', 'HH:mm:ss'), momentTime('11:59:59', 'HH:mm:ss')],
              }" :disabled-date="disabledDate" v-model:value="time" format="YYYY-MM-DD HH:mm:ss" valueFormat='YYYY-MM-DD HH:mm:ss'
              @change="(e)=>{form.use_exchange_start_time = e[0] || '';form.use_exchange_end_time = e[1] || ''}" />
            </div>
          </a-form-item>
          <a-form-item ref="" label="运费设置" name="">
            <a-select v-model:value="form.freight_tmp_id" :style="{width:'50%'}" placeholder="请选择">
              <a-select-option v-for='(item,index) in freightList' :key="index" :value="item.id">{{item.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item ref="" label="列表排序" name="" help='数值越大，排序越靠前'>
            <a-input-number class="width50" v-model:value="form.sort" placeholder='请输入排序' :min="0" :precision='0' />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
            <a-button type="primary" @click="onSubmit">立即上架</a-button>
            <a-button class="m-l-15" @click="current = 0">上一步</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="s_flex_center" v-show="current == 2">
        <div class="text-ac p-b-40">
          <p class="fz-30 m-b-15">恭喜，礼品设置成功</p>
          <a-button type="" @click='()=>{$router.go(-1)}'>返回列表</a-button>
        </div>
      </div>
    </a-card>
  </a-layout>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { exchangeGiftAdd, exchangeGiftEdit, exchangeGiftMore, getCategory } from "@/api/integralShop";
  import { getDeliveryList } from "@/api/order";
  import { getMemberVip } from "@/api/member.js";
  import { getPoint } from '@/api/assets';
  import { iscode } from "@/utils/app";
  import store from "@/store";
  import { useTree } from '@/hooks/useTree.js'
  import  moment from 'moment'
  let defForm = {
    name: '',
    product_id: '',
    product_type: '',
    ex_gift_cate_id: '',
    price_type: 1,
    price: '',
    point: '',
    use_exchange_num: '',
    use_exchange_type: 0,
    limit_num: false,
    limit_use: false,
    is_use_exchange_time:0,
    use_exchange_num_json: {
      date_type: 1,
      number: ''
    },
    level_type: 1,
    level_id: null,
    freight_tmp_id: null,
    sort:9999,
    spec_type: 1,
    sku: '',
  }
  export default {
    setup() {
      let price_type = async() =>{
        if (state.selectGood.spec_type == 1  && form.value.price_type == 1 && !isNumber(form.value.point)) {
          return Promise.reject('请输入积分');
        }else if (state.selectGood.spec_type == 1  && form.value.price_type == 2 && (!isNumber(form.value.point) || !isNumber(form.value.price))
         ) {
          return Promise.reject('积分或者金额不能为空');
        } else {
          return Promise.resolve();
        }
      }
      let use_exchange_num = async() =>{
        if (state.selectGood.spec_type == 1  && !isNumber(form.value.use_exchange_num)) {
          return Promise.reject('请输入可兑换数量');
        }else if (state.selectGood.spec_type == 2  && state.selectGood.sku.find(v=> !isNumber(v.use_exchange_num))) {
          return Promise.reject('请输入可兑换数量');
        }else if (state.selectGood.spec_type == 2 && form.value.price_type == 1 && state.selectGood.sku.find(v=> !isNumber(v.exchange_point))) {
          return Promise.reject('请输入积分');
        }else if (state.selectGood.spec_type == 2 && form.value.price_type == 2 && state.selectGood.sku.find(v=> !isNumber(v.exchange_point) || !isNumber(v.exchange_price))) {
          return Promise.reject('积分或者金额不能为空');
        }else {
          return Promise.resolve();
        }
      }
      const form = ref(JSON.parse(JSON.stringify(defForm)));
      const state = reactive({
        time:[],
        labelCol: { span: 3 },
        wrapperCol: { span: 20 },
        info: store.state.user.info,
        current: 0,
        goodList: [],
        giftList: [],
        selectGood: {},
        showTab: true,
        options: [],
        freightList: [],
        levelList: [],
        exchange_point: 0,
        activeKey: 1,
        valueCate: [],
        columns: [
          {
            title: "规格信息",
            dataIndex: "info",
            key: "info",
            slots: { customRender: "info" },
          },
          {
            title: "规格库存",
            dataIndex: "stock",
            key: "stock",
            slots: { customRender: "stock" },
          },
          {
            title: "积分价格",
            dataIndex: "price",
            key: "price",
            slots: { customRender: "price" },
          }
        ],
        rules: {
          price_type: [
            { required: true, validator: price_type }
          ],
          use_exchange_num: [
          { required: true, validator: use_exchange_num }
          ]
        }
      })
      const $router = inject('$router')
      const $route = inject('$route')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");
      const momentTime = inject("momentTime")
      const disabledDate = (current) => {
        return current && current <= moment(new Date() - 86400000).endOf('day');
      }
      const  isNumber = (obj) => {
        return !isNaN(parseFloat(obj)) && isFinite(obj);
      }
      // 选择礼品
      const selectGift = (e) => {
        state.current = 1
        state.selectGood = e
      }
      // 选择产品
      const goodSelect = (e) => {
        state.current = 1
        state.selectGood = e
      }
      // 打开新窗口
      const openNewUrl = (url) => {
        window.open(url);
      }
      //获取分类
      const initCate = async () => {
        let result = await getCategory().then((res) => res.data).catch((error) => error);
        if (iscode(result)) {
          state.options = useTree(result.data);
          state.options.map((v) => (v.disabled = v.child.length == 0 ? true : false));
          let pid
          for (var i in state.options) {
            if (state.options[i].child.length && $route.query.id) {
              for (var v in state.options[i].child) {
                if (state.options[i].child[v].id == form.value.ex_gift_cate_id) {
                  pid = state.options[i].child[v]
                  break
                }
              }
            }
          }
          if (pid) {
            state.valueCate = [pid.pid, pid.id]
          }
        } else {
          message.error(result.msg);
        }
      };
      //获取等级
      const getLevel = async () => {
        let res = await getMemberVip().then((res) => res.data);
        if (iscode(res)) {
          state.levelList = res.data;
        } else {
          message.error(res.msg);
        }
      };
      //获取积分设置
      const getPointSet = async () => {
        let res = await getPoint().then((res) => res.data);
        if (iscode(res)) {
          var data = res.data.values
          state.exchange_point = data.obtain_point;
        } else {
          message.error(res.msg);
        }
      };
      // 获取详情
      const getMore = async () => {
        const hide = message.loading('正在加载中...', 0);
        state.showTab = false
        let res = await exchangeGiftMore($route.query.id).then((res) => res.data).catch((error) => error);
        if (iscode(res)) {
          form.value = res.data
          state.time = [form.value.use_exchange_start_time,form.value.use_exchange_end_time]
          state.selectGood = {
            product_name: form.value.name,
            product_image: form.value.product_image,
            product_price: form.value.product_price,
            spec_type: form.value.spec_type,
            sku: form.value.sku,
            id: form.value.product_id
          }
          state.activeKey = form.value.product_type
          if (form.value.product_type == 1) {
            state.giftList = [state.selectGood]
          } else {
            state.goodList = [state.selectGood]
          }
          if (form.value.use_exchange_type == 3) {
            form.value.limit_num = true
            form.value.limit_use = true
          }
          if (form.value.use_exchange_type == 2) {
            form.value.limit_num = false
            form.value.limit_use = true
          }
          if (form.value.use_exchange_type == 1) {
            form.value.limit_num = true
            form.value.limit_use = false
          }
          if (form.value.use_exchange_type == 0) {
            form.value.limit_num = false
            form.value.limit_use = false
          }
          if(!form.value.use_exchange_num_json){
            form.value.use_exchange_num_json = {
              date_type: 1,
              number: ''
            }
          }
          initCate()
          setTimeout(() => {
            state.showTab = true
          }, 0)
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);

      }
      const ruleForm = ref()
      const onSubmit = () => {
        console.log(state.selectGood.sku)
        ruleForm.value.validate().then(async () => {
          console.log(state.selectGood.sku)
          let res
          const hide = message.loading('正在加载中...', 0);
          if (form.value.limit_num && form.value.limit_use) {
            form.value.use_exchange_type = 3
          }
          if (!form.value.limit_num && form.value.limit_use) {
            form.value.use_exchange_type = 2
          }
          if (form.value.limit_num && !form.value.limit_use) {
            form.value.use_exchange_type = 1
          }
          if (!form.value.limit_num && !form.value.limit_use) {
            form.value.use_exchange_type = 0
          }
          form.value.name = state.selectGood.product_name || state.selectGood.gift_name
          form.value.product_id = state.selectGood.id
          form.value.ex_gift_cate_id = state.valueCate[1]
          form.value.product_type = state.activeKey
          form.value.spec_type = state.selectGood.spec_type
          form.value.sku = state.selectGood.spec_type == 1 ? '' : state.selectGood.sku
          if ($route.query.id) {
            res = await exchangeGiftEdit(form.value).then(res => res.data).catch((error) => error);
          } else {
            res = await exchangeGiftAdd(form.value).then(res => res.data).catch((error) => error);
          }
          if (iscode(res)) {
            state.current = 2
          } else {
            message.error(res.msg);
          }
          setTimeout(hide);
        }).catch(error => {
          message.error('请完善表单！');
        });
      }// 获取运费模板
      const getFreight = async () => {
        let res = await getDeliveryList({ page: 1, limit: 99 }).then(res => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          state.freightList = res.data.data
          if (!$route.query.id) {
            form.value.freight_tmp_id =  state.freightList[0].id
          }
        } else {
          message.error(res.msg);
        }
      }
      onMounted(() => {
        initCate()
        getPointSet();
        getLevel();
        getFreight();
        if ($route.query.id) {
          getMore();
          state.current = 1
        } else {
          initCate()
        }
      });
      return {
        ...toRefs(state),
        goodSelect,
        selectGift,
        form,
        ruleForm,
        onSubmit,
        openNewUrl,
        getPointSet,
        initCate,
        disabledDate,
        momentTime,
        isNumber
      }
    }
  }
</script>